import { CrmExportHandlerProps } from "@/features/crm_system/lib/_core/crmSystem";
import { countErrorsInRowForFields } from "@/pages/ManageSurvey/ExportSurvey/utils";
import xlsx, { BookType } from 'xlsx';



export const workBookProps = {
    Title: "Survey Result",
    Subject: "Survey Result",
    Author: "Collaborate",
    CreatedDate: new Date()
}

const BOOK_TYPE: BookType = 'xlsx';

export async function exportSurveyResultToFile({ data, selectedColumns, exportInvalidRows }: CrmExportHandlerProps) {
    console.log(data)
    console.log(selectedColumns)
    
    // TODO Move to the function
    selectedColumns = ["Question", "Values", ...selectedColumns]
    const dataToExport = (exportInvalidRows ? data.refinedData : data.refinedData.filter(row => countErrorsInRowForFields(row, selectedColumns) === 0)).map((row) => {
        const onlySelectedColumns = selectedColumns.reduce((acc, key) => {
            if (key in row) {
                acc[key] = row[key];
            }
            return acc;
        }, {});
        return onlySelectedColumns;
    })
    const firstQuestion = dataToExport[0];
    const columnNames = firstQuestion ? Object.keys(firstQuestion) : [];

    try {
        const wsData = dataToExport.reduce<string[][]>((acc, item) => {
            const row = Object.keys(item).map(key => item[key]!.value);
            acc.push(row);
            return acc;
        }, [
            columnNames,
        ]);
        if (!wsData) return;

        const wb = xlsx.utils.book_new();
        wb.Props = workBookProps

        wb.SheetNames.push("Survey Result");

        const ws = xlsx.utils.aoa_to_sheet(wsData, {cellStyles: true});
        wb.Sheets["Survey Result"] = ws;

        ws['!cols'] = wsData[0].map((col: string[]) => {
            return { wch: col.length };
        });

        const wbout = xlsx.write(wb, { bookType: BOOK_TYPE, type: 'binary' });
        const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${data.survey.name}.${BOOK_TYPE}`;
        a.click();
        URL.revokeObjectURL(url);
    }
    catch (error) {
        console.log("error: ", error);
    }

}

function s2ab(s: string) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}